import React from 'react';
import PropTypes from 'prop-types';
import Heading from '../Content/Heading';
import Text from '../Content/Text';
import Image from '../Content/Image';
import DiagramImage from '../Content/DiagramImage';
import UnorderedList from '../Content/UnorderedList';
import OrderedList from '../Content/OrderedList';
import AccordionGroup from '../Content/AccordionGroup';
import Stream from '../Content/Stream';
import VimeoStream from '../Content/VimeoStream';
import Blockquote from '../Content/Blockquote';
import Cite from '../Content/Cite';

const SelectContentType = ({ content, loggedInUserId, authorId }) => {
  switch (content.type) {
    case 'heading':
      return <Heading text={content.data} />;
    case 'text':
      return <Text text={content.data} />;
    case 'image':
      if (content.data.type === 'pitch-diagram-snapshot-image') {
        return <DiagramImage image={content.data} loggedInUserId={loggedInUserId} authorId={authorId} />;
      }
      return <Image image={content.data} />;
    case 'bullet_list':
      return <UnorderedList list={content.data} />;
    case 'number_list':
      return <OrderedList list={content.data} />;
    case 'accordion':
      return <AccordionGroup content={content.data} />;
    case 'vimeo_stream':
      return <VimeoStream streamId={content.data.stream_id} title={content.data.title} />;
    case 'bespoke_stream':
    case 'youtube_stream':
    case 'soundcloud_stream':
      return <Stream iframe={content.data.iframe} />;
    case 'blockquote':
      return <Blockquote text={content.data} />;
    case 'cite':
      return <Cite text={content.data} />;

    default:
      return <Text text={content.data} />;
  }
};

SelectContentType.propTypes = {
  content: PropTypes.object,
  loggedInUserId: PropTypes.number,
  authorId: PropTypes.number,
};

export default SelectContentType;



// WEBPACK FOOTER //
// ./library/app/components/Content/SelectContentType.js